import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';

import { PlateComponent } from './plate.component';

/**
 * Shared module that owns the canonical <pla-plate> component (the
 * yellow plate render used site-wide on /build-your-own, plate detail
 * pages, search results, and now /new-release/:year). Extracted from
 * app.module so feature modules (e.g. new-release-page-v2) can import
 * the same renderer without duplicating its declaration.
 *
 * Required-by-template-or-class dependencies of PlateComponent:
 *   - Router (constructor) → RouterModule
 *   - MatDialog (constructor) → MatDialogModule
 *   - SessionService is providedIn:root so needs nothing here
 *   - PlateModalComponent is opened via MatDialog.open — declared in
 *     app.module; works as long as app.module is also loaded.
 *
 * The file-local AdminPlateImageComponent (selector pla-admin-plate)
 * is intentionally not declared here — it's a private MatDialog content
 * class used only inside PlateComponent itself, and it isn't declared
 * anywhere in the existing NgModule tree either.
 */
@NgModule({
  declarations: [PlateComponent],
  imports: [CommonModule, RouterModule, MatDialogModule],
  exports: [PlateComponent],
})
export class PlateComponentModule {}
